// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7z-0";
export var optionCard = "_7z-1";